/* Translation of locales/en-US/packs.ts (generated from lib/industryPacks/catalog.ts). Same keys;
 * only the values are translated. */
export const packs = {
  "property": {
    "assetTypes": {
      "0": "Maison",
      "1": "Appartement",
      "2": "Bureau",
      "3": "Chaudière",
      "4": "Installation électrique",
      "5": "Équipement incendie",
      "6": "Appareil"
    },
    "sample": {
      "name": "Bien d’exemple",
      "description": "Un bien d’exemple pour essayer une inspection avant d’ajouter les vôtres."
    },
    "templates": {
      "condition_inspection": {
        "name": "Inspection de l’état du bien",
        "description": "Parcourez le bien et notez son état pièce par pièce.",
        "items": {
          "0": {
            "label": "État extérieur et abords"
          },
          "1": {
            "label": "Toiture, gouttières et descentes d’eaux pluviales"
          },
          "2": {
            "label": "Fenêtres et portes extérieures"
          },
          "3": {
            "label": "Humidité, moisissures ou dégâts des eaux",
            "description": "Répondez oui s’il y en a."
          },
          "4": {
            "label": "Chauffage et eau chaude fonctionnels"
          },
          "5": {
            "label": "État intérieur général"
          }
        }
      },
      "room_inspection": {
        "name": "Inspection d’une pièce",
        "description": "Une seule pièce, assez détaillée pour régler un litige plus tard.",
        "groups": {
          "0": {
            "label": "État de la pièce",
            "guidance": "Scannez les murs, le plafond, le sol et les fenêtres. Montrez le détecteur de fumée s’il y en a un."
          },
          "1": {
            "label": "Réseaux et équipements"
          }
        },
        "items": {
          "0": {
            "label": "Murs et plafond"
          },
          "1": {
            "label": "Revêtement de sol"
          },
          "2": {
            "label": "Fenêtre et vitrage"
          },
          "3": {
            "label": "Détecteur de fumée présent"
          },
          "4": {
            "label": "Prises, interrupteurs et éclairage"
          },
          "5": {
            "label": "Aménagements et équipements fixes"
          },
          "6": {
            "label": "Propreté"
          }
        }
      },
      "move_in_out": {
        "name": "Entrée / sortie des lieux",
        "description": "Le constat que les deux parties approuvent lors de la remise des clés.",
        "items": {
          "0": {
            "label": "Relevés de compteurs notés"
          },
          "1": {
            "label": "Clés remises et comptées"
          },
          "2": {
            "label": "Détecteurs de fumée et de CO testés"
          },
          "3": {
            "label": "Propreté générale"
          },
          "4": {
            "label": "Dommages existants photographiés"
          },
          "5": {
            "label": "Appareils présents et fonctionnels"
          }
        }
      },
      "fire_safety_check": {
        "name": "Contrôle de sécurité incendie",
        "description": "Alarmes, issues et équipements. Des preuves, pas un avis juridique.",
        "items": {
          "0": {
            "label": "Détecteurs de fumée présents et qui sonnent"
          },
          "1": {
            "label": "Détecteur de monoxyde de carbone présent et qui sonne"
          },
          "2": {
            "label": "Issues de secours dégagées"
          },
          "3": {
            "label": "Portes coupe-feu qui se ferment complètement"
          },
          "4": {
            "label": "Extincteurs non périmés"
          },
          "5": {
            "label": "Éclairage de secours fonctionnel"
          }
        }
      },
      "maintenance_walkthrough": {
        "name": "Tournée d’entretien générale",
        "description": "Le tour de routine qui repère les problèmes tant qu’ils sont petits.",
        "items": {
          "0": {
            "label": "Plomberie et fuites visibles"
          },
          "1": {
            "label": "État du système de chauffage"
          },
          "2": {
            "label": "Électricité et câblage visible"
          },
          "3": {
            "label": "Portes, serrures et sécurité"
          },
          "4": {
            "label": "Abords et évacuation des eaux"
          }
        }
      }
    },
    "maintenance": {
      "boiler_annual_service": {
        "title": "Entretien annuel de la chaudière",
        "description": "Entretenir la chaudière et tenir à jour l’attestation de sécurité gaz."
      },
      "fire_safety_quarterly": {
        "title": "Contrôle trimestriel de sécurité incendie",
        "description": "Alarmes, issues de secours et équipements."
      }
    },
    "compliance": {
      "gas_safety": {
        "label": "Attestation de sécurité gaz"
      },
      "eicr": {
        "label": "Rapport d’état de l’installation électrique (EICR)"
      },
      "fire_safety": {
        "label": "Preuves de sécurité incendie, y compris les détecteurs de fumée et de CO"
      }
    }
  },
  "fleet": {
    "assetTypes": {
      "0": "Voiture",
      "1": "Fourgonnette",
      "2": "Camion",
      "3": "Remorque"
    },
    "sample": {
      "name": "Fourgonnette d’exemple",
      "description": "Un véhicule d’exemple pour essayer un contrôle quotidien avant d’ajouter les vôtres."
    },
    "templates": {
      "daily_vehicle_check": {
        "name": "Contrôle quotidien du véhicule",
        "description": "Le tour du véhicule avant de prendre la route.",
        "items": {
          "0": {
            "label": "Feux et clignotants"
          },
          "1": {
            "label": "Pneus et pressions"
          },
          "2": {
            "label": "Freinage normal"
          },
          "3": {
            "label": "Rétroviseurs et vitrages"
          },
          "4": {
            "label": "Niveaux des fluides"
          },
          "5": {
            "label": "Voyants allumés au tableau de bord",
            "description": "Répondez oui si l’un d’eux est allumé."
          },
          "6": {
            "label": "Chargement arrimé"
          }
        }
      },
      "vehicle_condition": {
        "name": "État du véhicule",
        "description": "Le relevé d’état complet, de la carrosserie à l’habitacle.",
        "groups": {
          "0": {
            "label": "Extérieur",
            "guidance": "Faites le tour du véhicule. Montrez chaque côté, les feux, les vitrages et les pneus."
          },
          "1": {
            "label": "Intérieur",
            "guidance": "Montrez les sièges, le tableau de bord et le compteur kilométrique."
          },
          "2": {
            "label": "Documents"
          }
        },
        "items": {
          "0": {
            "label": "État de la carrosserie"
          },
          "1": {
            "label": "Profondeur des sculptures des pneus acceptable"
          },
          "2": {
            "label": "Vitrages et rétroviseurs"
          },
          "3": {
            "label": "Feux intacts"
          },
          "4": {
            "label": "État de l’habitacle"
          },
          "5": {
            "label": "Relevé du compteur kilométrique"
          },
          "6": {
            "label": "Carnet d’entretien à jour"
          }
        }
      },
      "damage_inspection": {
        "name": "Inspection des dommages",
        "description": "Ce qui s’est passé, où, et à quoi cela ressemble.",
        "items": {
          "0": {
            "label": "Dommages photographiés sous tous les angles"
          },
          "1": {
            "label": "Véhicule toujours en état de rouler"
          },
          "2": {
            "label": "Panneaux et carrosserie"
          },
          "3": {
            "label": "Vitrages et feux intacts"
          },
          "4": {
            "label": "Tiers impliqué"
          }
        }
      },
      "handover": {
        "name": "Remise du véhicule",
        "description": "L’état et le contenu au moment où les clés changent de mains.",
        "items": {
          "0": {
            "label": "Relevé du compteur kilométrique noté"
          },
          "1": {
            "label": "Niveau de carburant ou de charge noté"
          },
          "2": {
            "label": "Clés et documents remis"
          },
          "3": {
            "label": "Dommages existants notés"
          },
          "4": {
            "label": "Propreté"
          }
        }
      },
      "tyres": {
        "name": "Contrôle des pneus",
        "description": "Sculptures, pression et état, roue par roue.",
        "items": {
          "0": {
            "label": "Avant gauche"
          },
          "1": {
            "label": "Avant droit"
          },
          "2": {
            "label": "Arrière gauche"
          },
          "3": {
            "label": "Arrière droit"
          },
          "4": {
            "label": "Roue de secours ou kit de réparation présent"
          }
        }
      },
      "service_check": {
        "name": "Contrôle d’entretien",
        "description": "Ce que l’atelier a examiné et ce qu’il a trouvé.",
        "items": {
          "0": {
            "label": "Relevé du compteur kilométrique noté"
          },
          "1": {
            "label": "Huile et filtre changés"
          },
          "2": {
            "label": "Freins inspectés"
          },
          "3": {
            "label": "Suspension et direction"
          },
          "4": {
            "label": "Codes défaut lus et effacés"
          }
        }
      }
    },
    "maintenance": {
      "service_whichever_first": {
        "title": "Entretien : 12 mois ou 10 000 miles",
        "description": "À la première échéance atteinte, à partir du dernier entretien terminé."
      },
      "service_calendar": {
        "title": "Entretien annuel",
        "description": "Tous les 12 mois à partir du dernier entretien terminé."
      },
      "service_mileage": {
        "title": "Entretien tous les 10 000 miles",
        "description": "Distance uniquement, à partir du relevé du dernier entretien."
      }
    },
    "compliance": {
      "roadworthy": {
        "label": "Contrôle d’aptitude à la circulation (par exemple le MOT)"
      },
      "insurance": {
        "label": "Assurance automobile"
      }
    }
  },
  "equipment": {
    "assetTypes": {
      "0": "Engin",
      "1": "Outil",
      "2": "Équipement de levage",
      "3": "Chariot élévateur",
      "4": "Compresseur"
    },
    "sample": {
      "name": "Engin d’exemple",
      "description": "Un engin d’exemple pour essayer un contrôle avant usage, en attendant d’ajouter les vôtres."
    },
    "templates": {
      "pre_use_check": {
        "name": "Contrôle avant usage",
        "description": "Le contrôle avant que l’opérateur commence le travail.",
        "items": {
          "0": {
            "label": "Protecteurs et dispositifs de sécurité en place"
          },
          "1": {
            "label": "Arrêt d’urgence fonctionnel"
          },
          "2": {
            "label": "Aucun dommage ni fuite visible"
          },
          "3": {
            "label": "Commandes et voyants fonctionnels"
          },
          "4": {
            "label": "Heures de fonctionnement relevées"
          }
        }
      },
      "condition_inspection": {
        "name": "Inspection de l’état",
        "description": "L’état de l’engin dans la durée.",
        "groups": {
          "0": {
            "label": "Identification de l’engin",
            "guidance": "Montrez la plaque signalétique et l’étiquette d’inventaire."
          },
          "1": {
            "label": "État extérieur",
            "guidance": "Scannez l’avant, les côtés et la base de l’équipement. Incluez les protecteurs, les flexibles et les raccords."
          },
          "2": {
            "label": "Données de fonctionnement",
            "guidance": "Montrez le compteur horaire."
          },
          "3": {
            "label": "Contrôle fonctionnel"
          }
        },
        "items": {
          "0": {
            "label": "Numéro de série"
          },
          "1": {
            "label": "État général"
          },
          "2": {
            "label": "Fuites visibles"
          },
          "3": {
            "label": "Protecteurs présents et fixés"
          },
          "4": {
            "label": "Câbles et connecteurs électriques"
          },
          "5": {
            "label": "Hydraulique et pneumatique"
          },
          "6": {
            "label": "Étiquettes et marquages lisibles"
          },
          "7": {
            "label": "Heures de fonctionnement"
          },
          "8": {
            "label": "Usure des pièces mobiles"
          },
          "9": {
            "label": "Démarre et fonctionne correctement"
          },
          "10": {
            "label": "Aucun bruit ni vibration anormal"
          }
        }
      },
      "maintenance_inspection": {
        "name": "Inspection de maintenance",
        "description": "La visite d’entretien planifiée et ce qu’elle a trouvé.",
        "items": {
          "0": {
            "label": "Heures de fonctionnement ou cycles relevés"
          },
          "1": {
            "label": "Graissage effectué"
          },
          "2": {
            "label": "Filtres et consommables remplacés"
          },
          "3": {
            "label": "Dispositifs de sécurité testés à nouveau"
          },
          "4": {
            "label": "Remis en service"
          }
        }
      },
      "calibration_evidence": {
        "name": "Contrôle des preuves d’étalonnage",
        "description": "Vérifier que l’étalonnage enregistré est à jour et traçable.",
        "items": {
          "0": {
            "label": "Certificat d’étalonnage au dossier"
          },
          "1": {
            "label": "Étalonnage toujours valide"
          },
          "2": {
            "label": "Étiquette d’étalonnage sur l’équipement"
          },
          "3": {
            "label": "Étalon de référence traçable"
          }
        }
      }
    },
    "maintenance": {
      "service_operating_hours": {
        "title": "Entretien toutes les 500 heures de fonctionnement",
        "description": "À partir du relevé d’heures du dernier entretien terminé.",
        "programmeTitle": "Programme aux heures de fonctionnement"
      },
      "service_operating_hours_major": {
        "title": "Entretien majeur toutes les 1 000 heures de fonctionnement",
        "description": "L’entretien approfondi, mesuré sur le même compteur horaire."
      },
      "service_cycles": {
        "title": "Révision générale tous les 2 000 cycles",
        "description": "À partir du nombre de cycles lors de la dernière révision terminée."
      }
    },
    "compliance": {
      "lifting": {
        "label": "Examen approfondi des équipements de levage"
      },
      "electrical": {
        "label": "Preuves de sécurité électrique, par exemple un rapport de test des appareils portables (PAT)"
      }
    }
  },
  "facilities": {
    "assetTypes": {
      "0": "Bâtiment",
      "1": "CVC",
      "2": "Pompe",
      "3": "Groupe électrogène",
      "4": "Système incendie",
      "5": "Distribution électrique"
    },
    "sample": {
      "name": "Bâtiment d’exemple",
      "description": "Un bâtiment d’exemple pour essayer une inspection avant d’ajouter les vôtres."
    },
    "templates": {
      "planned_maintenance": {
        "name": "Maintenance planifiée",
        "description": "La visite programmée sur un équipement technique.",
        "items": {
          "0": {
            "label": "Heures de fonctionnement relevées"
          },
          "1": {
            "label": "Filtres et courroies"
          },
          "2": {
            "label": "Fuites, bruit ou vibrations"
          },
          "3": {
            "label": "Commandes et consignes correctes"
          },
          "4": {
            "label": "Dispositifs d’isolement et de sécurité testés"
          }
        }
      },
      "condition_inspection": {
        "name": "Inspection de l’état",
        "description": "L’état du bâtiment et de ses installations dans la durée.",
        "items": {
          "0": {
            "label": "Structure et enveloppe du bâtiment"
          },
          "1": {
            "label": "Toiture et évacuation des eaux"
          },
          "2": {
            "label": "Installations mécaniques"
          },
          "3": {
            "label": "Distribution électrique"
          },
          "4": {
            "label": "Parties communes"
          }
        }
      },
      "safety_inspection": {
        "name": "Inspection de sécurité",
        "description": "Ce qui doit être en ordre avant que quiconque entre dans le bâtiment.",
        "items": {
          "0": {
            "label": "Centrale d’alarme incendie sans défaut"
          },
          "1": {
            "label": "Issues de secours et sorties finales dégagées"
          },
          "2": {
            "label": "Éclairage de secours fonctionnel"
          },
          "3": {
            "label": "Extincteurs non périmés et en place"
          },
          "4": {
            "label": "Signalisation présente et lisible"
          }
        }
      },
      "plant_room_check": {
        "name": "Contrôle du local technique",
        "description": "Le tour de routine du local technique.",
        "items": {
          "0": {
            "label": "Local technique fermé et dégagé"
          },
          "1": {
            "label": "Aucune fuite ni eau stagnante"
          },
          "2": {
            "label": "Pressions et températures dans les plages normales"
          },
          "3": {
            "label": "Alarmes et voyants normaux"
          },
          "4": {
            "label": "Ventilation non obstruée"
          }
        }
      },
      "energy_walkround": {
        "name": "Tournée énergie et environnement",
        "description": "Un tour d'un bâtiment pour repérer l'énergie et l'eau gaspillées, et vérifier que les compteurs ont été relevés.",
        "items": {
          "0": {
            "label": "Compteurs relevés ce mois-ci"
          },
          "1": {
            "label": "Lumières éteintes dans les zones vides"
          },
          "2": {
            "label": "Chauffage et climatisation réglés aux températures convenues"
          },
          "3": {
            "label": "Chauffage et climatisation ne fonctionnent pas en même temps"
          },
          "4": {
            "label": "Portes et fenêtres fermées là où l'on chauffe ou climatise"
          },
          "5": {
            "label": "Pas de robinets qui gouttent ni de chasses d'eau qui coulent"
          },
          "6": {
            "label": "Équipements éteints hors des heures d'ouverture"
          },
          "7": {
            "label": "Certificat énergétique affiché là où c'est requis"
          }
        }
      },
      "fgas_leak_check": {
        "name": "Contrôle d'étanchéité gaz fluorés",
        "description": "Le contrôle d'étanchéité périodique d'une installation contenant un fluide frigorigène fluoré, par un technicien certifié.",
        "items": {
          "0": {
            "label": "Technicien certifié gaz fluorés"
          },
          "1": {
            "label": "Raccords, vannes et joints contrôlés"
          },
          "2": {
            "label": "Système de détection des fuites opérationnel (si installé)"
          },
          "3": {
            "label": "Pas de traces d'huile aux raccords"
          },
          "4": {
            "label": "Fluide ajouté (saisir les kg sur l'équipement)"
          },
          "5": {
            "label": "Fuite trouvée"
          },
          "6": {
            "label": "La plaque indique le type de fluide et la charge"
          }
        }
      }
    },
    "maintenance": {
      "ppm_quarterly": {
        "title": "Maintenance planifiée trimestrielle",
        "description": "Tous les 3 mois à partir de la dernière visite terminée."
      },
      "generator_hours": {
        "title": "Entretien du groupe électrogène toutes les 250 heures de fonctionnement",
        "description": "À partir du relevé d’heures du dernier entretien terminé."
      }
    },
    "compliance": {
      "energy_performance": {
        "label": "Certificat de performance énergétique (DPE/EPC)"
      },
      "water_hygiene": {
        "label": "Preuves d’hygiène de l’eau, par exemple une évaluation du risque légionelle"
      },
      "fire_safety": {
        "label": "Preuves de sécurité incendie"
      },
      "lifting": {
        "label": "Examen approfondi des équipements de levage"
      },
      "electrical": {
        "label": "Rapport d’état de l’installation électrique (EICR)"
      }
    }
  }
};
